import React from 'react';
import { ChevronRight } from 'lucide-react';
export function Button({
  children,
  className = '',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const el = document.getElementById('oferta');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 rounded-lg bg-green-500 px-8 py-4 text-xl font-bold text-white shadow-[0_0_20px_rgba(34,197,94,0.4)] transition-all hover:-translate-y-1 hover:bg-green-400 hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] focus:outline-none focus:ring-4 focus:ring-green-500/50 ${className}`} data-id="element-14">
      {children}
      <ChevronRight className="h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-15" />
    </button>;
}